import { formatDistanceToNow } from 'date-fns';
import { cn } from '@/lib/utils/cn';
import { usePresenceStore } from '@/stores/presenceStore';

type Props = {
  profileId: string;
  lastSeenAt?: string | null;
  mode?: 'dot-only' | 'dot-with-text';
  className?: string;
};

const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

export function OnlineIndicator({ profileId, lastSeenAt, mode = 'dot-only', className }: Props) {
  const isOnline = usePresenceStore((s) => s.isOnline(profileId));

  const recentlyActive =
    !isOnline && lastSeenAt
      ? Date.now() - new Date(lastSeenAt).getTime() < TWENTY_FOUR_HOURS
      : false;

  if (!isOnline && !recentlyActive) return null;

  if (mode === 'dot-only') {
    return (
      <span
        className={cn(
          'absolute bottom-0 right-0 h-3 w-3 rounded-full ring-2 ring-white',
          isOnline ? 'bg-success' : 'bg-muted',
          className,
        )}
        aria-hidden="true"
      />
    );
  }

  return (
    <span className={cn('flex items-center gap-1.5 text-xs text-muted', className)}>
      <span
        className={cn('h-2 w-2 rounded-full', isOnline ? 'bg-success' : 'bg-muted')}
        aria-hidden="true"
      />
      {isOnline
        ? 'Active now'
        : `Last seen ${formatDistanceToNow(new Date(lastSeenAt!), { addSuffix: true })}`}
    </span>
  );
}
